import React, { useState } from 'react';
import './collapse.bar.css';

const CollapseBar = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [hideContent, setHideContent] = useState(false); // For conditional display:none

  const toggleCollapse = () => {
    if (isAnimating) return;

    setIsAnimating(true);
    setIsCollapsed((prev) => !prev);

    if (isCollapsed) {
      setHideContent(false); // Show content immediately when expanding.
    }

    setTimeout(() => setIsAnimating(false), 500); // Duration matches animation time
  };

  const handleAnimationEnd = () => {
    if (isCollapsed) {
      setHideContent(true); // Hide content after animation completes on collapse
    }
  };

  return (
    <div
      className={`collapse-bar ${isCollapsed ? 'collapsed' : 'expanded'} ${
        isAnimating ? 'animating' : ''
      }`}
    >
      <button onClick={toggleCollapse} className="collapse-toggle-btn">
        <span></span>
        <span></span>
      </button>
      <div
        className="collapse-content"
        onAnimationEnd={handleAnimationEnd}
        style={{ display: hideContent ? 'none' : 'block' }}
      >
        {children}
      </div>
    </div>
  );
};

export default CollapseBar;
